export default __webpack_public_path__ + "static/210511_KWM_by_Kruszewski_5MK_6416_background-9df2f07e1c5605c9d00a601d8293a630.mp4";